import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WidgetProductSettingsResponse } from './state/widget.state.model';

@Injectable({
  providedIn: 'root',
})
export class WidgetConfigService {
  constructor(private http: HttpClient) {}

  getWidgetSettings(productAccountId: string): Observable<WidgetProductSettingsResponse> {
    return this.http.get<WidgetProductSettingsResponse>(
      `/ws/product/account/settings?product_acctid=${productAccountId}`,
    );
  }
}
